/* eslint-disable react-hooks/exhaustive-deps */
import { useNavigate, useParams } from "react-router";
import {
  ControlledInput,
  PrimaryButton,
  SecondaryButton,
} from "../../components";
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { useForm } from "react-hook-form";
import { useArticles } from "../../store/useArticles";
import { useEffect } from "react";

type Inputs = {
  title: string;
};

function EditArticleCategoryScreen() {
  /** Hooks */
  const params = useParams();
  const {
    articleCategory,
    getArticleCategory,
    updateArticleCategory,
    updatedArticleCategory,
    clearUpdatedArticleCategory,
  } = useArticles();
  const navigate = useNavigate();
  const {
    reset,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>();

  const onSubmit = (data: Inputs) =>
    updateArticleCategory(params?.id as string, data.title);

  useEffect(() => {
    if (updatedArticleCategory) {
      clearUpdatedArticleCategory();
      navigate("/article-categories");
    }
  }, [updatedArticleCategory]);

  useEffect(() => {
    if (params?.id) {
      getArticleCategory(params?.id);
    }
  }, [params?.id]);

  useEffect(() => {
    reset({ title: articleCategory?.title });
  }, [articleCategory]);

  const goBack = () => navigate(-1);
  return (
    <div>
      <div className="flex flex-row items-center mb-6">
        <h1 className="font-satoshi text-2xl font-bold text-dark">
          Add new article category
        </h1>
      </div>
      <div className="w-1/2 bg-white border border-gray-border drop-shadow-md">
        <div className="w-full border-b border-gray-border px-[28px] py-[15px]">
          <p className="font-satoshi font-medium text-base text-dark">
            New user
          </p>
        </div>
        <form onSubmit={handleSubmit(onSubmit)} className="w-full px-7 py-7">
          {/* Title */}
          <ControlledInput
            name="title"
            rules={{ required: true }}
            control={control}
            error={Boolean(errors?.title)}
            label="Title"
            type="text"
            placeholder="Enter title here"
          />
          <div className="flex flex-row items-center justify-end">
            <SecondaryButton type="submit" label="Cancel" />
            <PrimaryButton onClick={goBack} className="ml-4" label="Save" />
          </div>
        </form>
      </div>
    </div>
  );
}

export default withProtectedRoute(EditArticleCategoryScreen);
